import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initPWA } from './utils/pwa.ts';
import ErrorBoundary from './components/ErrorBoundary.tsx';

// Console inspector/filters removed

// Initialize PWA features with better update handling
initPWA();

// Global error handler for unhandled promise rejections and runtime errors
window.addEventListener('unhandledrejection', (event) => {
  // Filter out known third-party extension errors
  const isExtensionError = event.reason?.message?.includes('Extension context') ||
    event.reason?.message?.includes('message channel closed') ||
    event.reason?.stack?.includes('extension://');

  const isReplayError = event.reason?.message?.includes('replayIntegration');

  // Filter out StackBlitz/Vite preview ConsoleInspector noise
  const reasonMsg = typeof event.reason === 'string' ? event.reason : event.reason?.message || '';
  const isConsoleInspector = reasonMsg.includes('ConsoleInspector') || reasonMsg.includes('Console Inspector');
  const isPreviewScript = reasonMsg.includes('/.preview-scri');

  if (isExtensionError || isReplayError || isConsoleInspector || isPreviewScript) {
    event.preventDefault(); // Prevent logging these errors
    return;
  }

  console.error('Unhandled promise rejection:', event.reason);
});

window.addEventListener('error', (event) => {
  // Filter out known third-party extension errors
  const isExtensionError = event.filename?.includes('extension://') ||
    event.error?.stack?.includes('extension://') ||
    event.message?.includes('Extension context');

  const isReplayError = event.message?.includes('replayIntegration');

  // Filter out StackBlitz/Vite preview ConsoleInspector noise
  const isConsoleInspector = event.message?.includes('ConsoleInspector') || event.message?.includes('Console Inspector');
  const isPreviewScript = event.filename?.includes('/.preview-scri') || event.message?.includes('/.preview-scri');

  if (isExtensionError || isReplayError || isConsoleInspector || isPreviewScript) {
    event.preventDefault(); // Prevent logging these errors
    return;
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
